import { BentoItem } from "./BentoItem";
import { BentoRoot } from "./BentoRoot";

export const Bento = Object.assign(BentoRoot, {
  Item: BentoItem,
});
